import React, {useEffect, useState} from 'react';
import persianDate from "persian-date";
import {Dropdown} from "primereact/dropdown";
import DatePicker, {DateObject} from "react-multi-date-picker";
import InputDate from "./input-date";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import {useTranslate} from "../useTranslate";

function LimitByDate({selectedLimit, onChange}) {
    const translate = useTranslate();
    const [value, setValue] = useState();
    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();

    const options = [
        {label:translate("today"), value:"today"},
        {label:translate("yesterday"), value:"yesterday"},
        {label:translate("this-week"), value:"this-week"},
        {label:translate("this-month"), value:"this-month"},
        {label:translate("this-year"), value:"this-year"},
        {label:translate("any-date-limit"), value:"any-date-limit"},
    ]

    const handleOnChange=(e)=>{
        setValue(e.value);
        let dateLimit;
        switch (e.value) {
            case "today":
                dateLimit = {value:e.value, date_from:new persianDate().startOf('day').unix(), date_to:new persianDate().endOf("day").unix()};
                onChange(dateLimit)
                break;
            case "this-week":
                dateLimit = {value:e.value, date_from:new persianDate().startOf('week').hour(0).minute(0).second(0).unix(), date_to:new persianDate().endOf("week").unix()};
                onChange(dateLimit)
                break;
            case "this-month":
                dateLimit = {value:e.value, date_from:new persianDate().startOf('month').unix(), date_to:new persianDate().endOf("month").unix()};
                onChange(dateLimit)
                break;
            case "this-year":
                dateLimit = {value:e.value, date_from:new persianDate().startOf('year').unix(), date_to:new persianDate().unix()};
                onChange(dateLimit)
                break;
            case "yesterday":
                dateLimit = {value:e.value, date_from:new persianDate().subtract('days', 1).startOf('day').unix(), date_to:new persianDate().subtract('days', 1).endOf("day").unix()};
                onChange(dateLimit)
                break;
            default:
                dateLimit = {value:e.value, date_from:new persianDate().startOf('day').unix(), date_to:new persianDate().endOf("day").unix()};
                onChange(dateLimit)
        }

        setDateFrom(dateLimit.date_from);
        setDateTo(dateLimit.date_to);
    }

    useEffect(()=>{
        setValue(selectedLimit);
        let dateLimit;
        switch (selectedLimit) {
            case 'today':
                dateLimit = {value:selectedLimit, date_from:new persianDate().startOf('day').unix(), date_to:new persianDate().endOf("day").unix()};
                onChange(dateLimit)
                break;
            case 'this-week':
                dateLimit = {value:selectedLimit, date_from:new persianDate().startOf('week').hour(0).minute(0).second(0).unix(), date_to:new persianDate().endOf("week").unix()};
                onChange(dateLimit)
                break;
            case 'this-month':
                dateLimit = {value:selectedLimit, date_from:new persianDate().startOf('month').unix(), date_to:new persianDate().endOf("month").unix()};
                onChange(dateLimit)
                break;
            case 'this-year':
                dateLimit = {value:selectedLimit, date_from:new persianDate().startOf('year').unix(), date_to:new persianDate().unix()};
                onChange(dateLimit)
                break;
            case "yesterday":
                dateLimit = {value:selectedLimit, date_from:new persianDate().subtract('days', 1).startOf('day').unix(), date_to:new persianDate().subtract('days', 1).endOf("day").unix()};
                onChange(dateLimit)
                break;
            default:
                dateLimit = {value:selectedLimit, date_from:new persianDate().startOf('day').unix(), date_to:new persianDate().endOf("day").unix()};
                onChange(dateLimit)
        }

        setDateFrom(dateLimit.date_from);
        setDateTo(dateLimit.date_to);
    },[selectedLimit])

    return(
        <div className="flex flex-wrap justify-content-end align-items-center gap-2">
            <Dropdown panelClassName="text-right" options={options} value={value} defaultValue={value} onChange={handleOnChange}/>
            {
                value==='any-date-limit' && (
                    <>
                        <DatePicker plugins={[<TimePicker hideSeconds position="bottom" />]} value={dateFrom && new DateObject(dateFrom*1000)} onChange={(e)=>{onChange({value:5, date_from:e.toUnix(), date_to:dateTo}); setDateFrom(e.toUnix())}} render={<InputDate/>} calendar={persian} locale={persian_fa} calendarPosition="bottom-right"/>
                        <DatePicker plugins={[<TimePicker hideSeconds position="bottom" />]} value={dateTo && new DateObject(dateTo*1000)} onChange={(e)=>{onChange({value:5, date_from:dateFrom, date_to:e.toUnix()}); setDateTo(e.toUnix())}} render={<InputDate/>} calendar={persian} locale={persian_fa} calendarPosition="bottom-right"/>
                    </>
                )
            }

        </div>
    )
}

export function useDateLimit() {

    const getDateLimit=(value)=>{
        switch (value) {
            case 'today':
                return {value, date_from:new persianDate().startOf('day').unix(), date_to:new persianDate().endOf("day").unix()};
            case 'this-week':
                return {value, date_from:new persianDate().startOf('week').hour(0).minute(0).second(0).unix(), date_to:new persianDate().endOf("week").unix()};
            case 'this-month':
                return {value, date_from:new persianDate().startOf('month').unix(), date_to:new persianDate().endOf("month").unix()};
            case 'this-year':
                return {value, date_from:new persianDate().startOf('year').unix(), date_to:new persianDate().unix()};
            case "yesterday":
                return {value, date_from:new persianDate().subtract('days', 1).startOf('day').unix(), date_to:new persianDate().subtract('days', 1).endOf("day").unix()};
            default:
                return {value, date_from:new persianDate().startOf('day').unix(), date_to:new persianDate().endOf("day").unix()};
        }
    }
    return {getDateLimit}
}


export default LimitByDate;